function hexToRgbPercentage(hex: string) {
  return (
    hex
      .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => '#' + r + r + g + g + b + b)
      .substring(1)
      .match(/.{2}/g)
      ?.map((x) => parseInt(x, 16) / 255) || [0, 0, 0]
  );
}

export type HSL = [number, number, number];

export function hexToHsl(hex: string): HSL {
  const [r, g, b] = hexToRgbPercentage(hex);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);

  const l = (max + min) / 2;
  if (max === min) return [0, 0, l];

  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

  let h;
  if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
  else if (max === g) h = (b - r) / d + 2;
  else h = (r - g) / d + 4;
  h /= 6;

  return [h, s, l];
}

export function hslToString(hsl: HSL): string {
  let [h, s, l] = hsl;
  h = Math.round(h * 360);
  s = Math.round(s * 100);
  l = Math.round(l * 100);
  return `${h}deg ${s}% ${l}%`;
}

export function isLightColor(hex: string): boolean {
  const values = hexToRgbPercentage(hex);
  const r = values[0] * 255;
  const g = values[1] * 255;
  const b = values[2] * 255;

  // HSP equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  return hsp > 127.5;
}
